import {
  Box,
  Center,
  Circle,
  Image,
  Text,
  VStack,
  SlideFade,
} from '@chakra-ui/react';
import React, { useContext, useState } from 'react';
import Container from '../../../components/Container';
import Header from '../../../components/Header';
import IssueCard from './IssueCard';
import { BsFillPlusCircleFill } from 'react-icons/bs';
import { v4 } from 'uuid';
import { useNavigate } from 'react-router-dom';
import { PROTECTED_PATHS } from '../../../app/constants';
import { useEffect } from 'react';
import { getIssueReports } from '../services/getIssueReports';
import { AuthContext } from '../../../context/authContext';
import FullPageLoader from '../../../components/FullPageLoader';

const IssueReportsHistory = () => {
  const [issueReports, setIssueReports] = useState([]);
  const [loading, setLoading] = useState(false);

  const {
    userInfo: { userId },
  } = useContext(AuthContext);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    getIssueReports(userId, setIssueReports, setLoading);
  }, [userId, refresh]);

  const { ISSUE_REPORT } = PROTECTED_PATHS;
  const navigate = useNavigate();

  return loading ? (
    <FullPageLoader />
  ) : (
    <SlideFade in={true} offsetX='2000px'>
      <Box pos='relative'>
        <Box shadow='xs'>
          <Container>
            <Header goto={ISSUE_REPORT} />
          </Container>
        </Box>
        <Container>
          {issueReports.length > 0 &&
            issueReports?.map((issue) => (
              <IssueCard
                issue={issue}
                key={v4()}
                setRefresh={() => setRefresh(!refresh)}
              />
            ))}

          {!issueReports ||
            (!issueReports.length && (
              <Center h='calc(100vh - 150px)'>
                <VStack>
                  <Image src='/Empty.svg' alt='Empty' />
                  <Text as='h2' py='5'>
                    You have no reported Issue
                  </Text>
                </VStack>
              </Center>
            ))}
          <Circle
            cursor='pointer'
            pos='fixed'
            bottom='10vh'
            right='10%'
            shadow='md'
          >
            <BsFillPlusCircleFill
              color='#614385'
              size={35}
              onClick={() => navigate(ISSUE_REPORT)}
            />
          </Circle>
        </Container>
      </Box>
    </SlideFade>
  );
};

export default IssueReportsHistory;
